import * as actionTypes from '../../actionTypes';
import axios from '../../../../_services/api/axios';

/* ------------------ Company Update ------------------- */
export const settingsCompanyUpdateStart = () => {
    return {
        type: actionTypes.SETTINGS_COMPANY_UPDATE_START
    };
};

export const settingsCompanyUpdateSuccess = (settings) => {
    return {
        type: actionTypes.SETTINGS_COMPANY_UPDATE_SUCCESS,
        settings: settings
    };
};

export const settingsCompanyUpdateFail = ( error ) => {
    return {
        type: actionTypes.SETTINGS_COMPANY_UPDATE_FAIL,
        error: error
    };
};

export const settingsCompanyUpdateReset = ( error ) => {
    return {
        type: actionTypes.SETTINGS_COMPANY_UPDATE_RESET,
        error: error
    };
};

export const settingsCompanyUpdate = (formData) => {
    return dispatch => {
        dispatch(settingsCompanyUpdateStart());
        axios.put( '/production/calculator/settings', formData)
            .then( response => { 
                dispatch( settingsCompanyUpdateSuccess( response.data ) );
            } )
            .catch( error => {
                dispatch( settingsCompanyUpdateFail( error ) );               
            } );
    };
};

/* ------------------ Company Fetch ------------------- */
export const settingsCompanyFetchStart = () => {
    return {
        type: actionTypes.SETTINGS_COMPANY_FETCH_START
    };
};

export const settingsCompanyFetchSuccess = (settings) => {
    return {
        type: actionTypes.SETTINGS_COMPANY_FETCH_SUCCESS,
        settings: settings
    };
};

export const settingsCompanyFetchFail = ( error ) => {
    return {
        type: actionTypes.SETTINGS_COMPANY_FETCH_FAIL,
        error: error
    };
};

export const settingsCompanyFetchReset = ( error ) => {
    return {
        type: actionTypes.SETTINGS_COMPANY_FETCH_RESET,
        error: error
    };
};

export const settingsCompanyFetch = () => {
    return dispatch => {
        dispatch(settingsCompanyFetchStart());
        axios.get( '/production/calculator/settings')
            .then( response => {
                dispatch( settingsCompanyFetchSuccess( response.data ) );
            } )
            .catch( error => {
                if(error.length && error.length === 1) {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "company", key: error[0].key, message: error[0].message, type: 'error'} } ); 
                }
                else {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "company", key: "default", message: "There was an error, please try it again later.", type: 'error', obj: error} } ); 
                }
                dispatch( settingsCompanyFetchFail( error ) );              
            } );
    };
};



// WEBPACK FOOTER //
// ./src/_store/actions/calculator/settings/company.js